<template>
  <div class="news-container">
    <div class="header">
      <div class="title">
        <img
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x6.png"
          alt=""
        />
        <span>精品<span class="highlight">课程</span></span>
        <div class="ll"></div>
        <span class="lll">PREMIUM COURSES</span>
      </div>
      <div @click="goNext('/jingpin/courer')"  class="more">
        查看更多
        <img
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x7.png"
          alt=""
        />
      </div>
    </div>
    <div class="course-list">
      <div
      @click="goPage(course)"
        v-for="(course, index) in courses"
        :key="index"
        class="course-card"
        :class="course.bgClass"
      >
       <img style="width: 265px;
height: 148px;
border-radius: 10px 10px 0px 0px;" :src="course.img" alt="">
        <div class="titles twoEllipsis">{{ course.title }}</div>
     
        <div class="price-popularity">
          <span class="price"> <span>¥</span>{{ course.price }}</span>
          <span class="popularity">
           <img style="width: 10px;margin-right: 4px;"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x9.png"
          alt=""
        /> {{ course.clicks }}人气值
          </span>
        </div>
      </div>
    </div>
    <img
      style="width: 1400px;height: 130px;border-radius: 10px;margin-top: 10px; "
      :src="imgs.img"
      alt=""
    />
  </div>
</template>

<script>
import { Know } from "@/api/know";
const know = new Know();
import { queryAllArticle } from "@/api/home";

export default {
  name: "NewsDynamic",
  data() {
    return { 
       courses: [ 
      ],
      imgs:{}
    };
  },
  created() {
    this.getList();
  },
  methods: {
     goPage(item) {
      if (!item) {
        return
      }
      /*  1直播  2 点播  3 音频 4 图文  5 面授  6 课程方向 */
      if (item.types == 1) {
        const routeUrl = this.$router.resolve({
          path: '/zhiboclassxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 2) {
        const routeUrl = this.$router.resolve({
          path: '/videoxq',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 3) {
        const routeUrl = this.$router.resolve({
          path: '/audioCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 4) {
        const routeUrl = this.$router.resolve({
          path: '/imgCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      } else if (item.types == 5) {
        const routeUrl = this.$router.resolve({
          path: '/faceCouser/index',
          query: {
            id: item.id
          }
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    async getList() {
      know.getCourseListnew(10, 1).then((res) => {
     
        this.courses = res.rows
      })
      know.getAdvertisingSurface().then((res) => {
     
        this.imgs = res.data
      })
      
    },
  },
};
</script>

<style lang="scss" scoped>
.news-container {
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-top: 40px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;

  font-family: DingTalk JinBuTi, DingTalk JinBuTi;
  font-weight: 400;
  font-size: 34px;

  img {
    width: 41px;
    margin-right: 9px;
  }

  .ll {
    margin: 0 17px;
    width: 0px;
    height: 28px;
    border-right: 1px solid #bbbbbb;
  }

  .lll {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}

.title .icon-news {
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  margin-right: 8px;
}

.title .highlight {
  color: #007bff;
  margin-left: 4px;
}

.more {
  cursor: pointer;
  display: flex;
  align-items: center;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  img {
    width: 31px;
    margin-left: 4px;
  }
}

.course-list {
  display: flex;
  flex-wrap: wrap;  
}

.course-card {
  width: 265px;
  height: 270px;
  border-radius: 10px;  
  cursor: pointer;
  display: flex;
  flex-direction: column; 
  background: #FFFFFF;
  margin-right: 18px;
  margin-bottom: 20px;
  &:nth-child(5n) {
    margin-right: 0;
  }
   .titles{
    width: 235px;
height: 52px;
font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 18px;
color: #333333;
line-height: 26px; 
margin: 14px;
   }
  
}
  .price-popularity {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 14px;
    .price {
   
font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 20px;
color: #FB2D25; 
span{
font-size: 14px;
margin-right: 4px;

}
    }
    .popularity { 
      display: flex;
      align-items: center;
   
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #999999; 
       
    }
  }
</style>
